import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const SalesReports = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Satış Raporları
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Satış raporları burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default SalesReports;
